import React, { useState } from 'react';
import styles from './ButtonNavbarItem.module.scss';

type IButtonNavbarItem = {
  variant?: 'desktop' | 'mobile';
  onClick?: () => void;
  isActive?: boolean;
  type?:
    | 'add'
    | 'mythic-portal'
    | 'account-setting'
    | 'logout'
    | 'login'
    | 'user-feedback';
  text?: string;
  /** When set the item renders as a real anchor instead of a div. */
  href?: string;
};

const ButtonNavbarItem: React.FC<IButtonNavbarItem> = ({
  variant = 'desktop',
  onClick,
  isActive = false,
  type = 'mythic-portal',
  text = 'Log out',
  href
}) => {
  const [isBlink, setIsBlink] = useState<boolean>(false);
  const className = `${styles['container']} ${isActive && styles['active']} ${
    variant === 'mobile' && styles['mobile']
  } ${isBlink && styles['blink']}`;
  const content = (
    <>
      <img src={`/assets/icons/${type}.png`} alt="icon" />
      <p className={`${variant === 'mobile' && styles['mobile']}`}>{text}</p>
    </>
  );

  if (href) {
    return (
      <a
        className={`${className} ${styles['link']}`}
        href={href}
        onClick={onClick}
        onMouseDown={() => setIsBlink((prev) => !prev)}
        onMouseUp={() => setIsBlink((prev) => !prev)}
      >
        {content}
      </a>
    );
  }

  return (
    <div
      className={className}
      onClick={onClick}
      onMouseDown={() => setIsBlink((prev) => !prev)}
      onMouseUp={() => setIsBlink((prev) => !prev)}
    >
      {content}
    </div>
  );
};

export default ButtonNavbarItem;
